import { render, staticRenderFns } from "./MarqeenContent.vue?vue&type=template&id=788b5c6c&"
import script from "./MarqeenContent.vue?vue&type=script&lang=js&"
export * from "./MarqeenContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports